var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.theme }, [
    _vm.jsonData.pcBg !== "" && _vm.jsonData.pcBg !== null
      ? _c("div", [
          _c("img", {
            staticStyle: { width: "100%", height: "100%" },
            attrs: { src: _vm.jsonData.pcBg },
          }),
        ])
      : _vm._e(),
    _vm.jsonData.pcBg === "" || _vm.jsonData.pcBg === null
      ? _c("div", { staticClass: "home" }, [
          _vm.theme == "blue"
            ? _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "left" }, [
                  _c(
                    "div",
                    {
                      class:
                        _vm.theme == "blue" && this.isLongChart
                          ? "name1"
                          : "name",
                    },
                    [_vm._v(_vm._s(_vm.jsonData.companyName))]
                  ),
                  _c(
                    "div",
                    {
                      class:
                        _vm.theme == "blue" && this.isLongChart
                          ? "en-name1"
                          : "en-name",
                    },
                    [_vm._v(_vm._s(_vm.jsonData.companyNameEng))]
                  ),
                  _vm._m(0),
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.jsonData.fs)),
                  ]),
                  _c("div", { staticClass: "en-title" }, [
                    _vm._v(_vm._s(_vm.jsonData.fsEng)),
                  ]),
                  _c("div", { staticClass: "code" }, [
                    _c("div", { staticClass: "code-bg" }, [
                      _vm.language === "zh"
                        ? _c("span", { staticClass: "text" }, [
                            _vm._v(
                              " 股票代码：" +
                                _vm._s(_vm.jsonData.companyCode) +
                                " | 所属行业：" +
                                _vm._s(_vm.jsonData.xfhy)
                            ),
                          ])
                        : _vm.language === "en"
                        ? _c("span", { staticClass: "text f-14" }, [
                            _vm._v(
                              " Stock Code：" +
                                _vm._s(_vm.jsonData.companyCode) +
                                " ｜ Industry： " +
                                _vm._s(_vm.jsonData.xfhyEng)
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
                _vm._m(1),
              ])
            : _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.jsonData.companyName)),
                ]),
                _c("div", { staticClass: "en-name" }, [
                  _vm._v(_vm._s(_vm.jsonData.companyNameEng)),
                ]),
                _vm._m(2),
                _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.jsonData.fs)),
                ]),
                _c("div", { staticClass: "en-title" }, [
                  _vm._v(_vm._s(_vm.jsonData.fsEng)),
                ]),
                _c("div", { staticClass: "code" }, [
                  _c("div", { staticClass: "code-bg" }, [
                    _vm.language === "zh"
                      ? _c("span", { staticClass: "text" }, [
                          _vm._v(
                            " 股票代码：" +
                              _vm._s(_vm.jsonData.companyCode) +
                              " | 所属行业：" +
                              _vm._s(_vm.jsonData.xfhy)
                          ),
                        ])
                      : _vm.language === "en"
                      ? _c("span", { staticClass: "text f-14" }, [
                          _vm._v(
                            " Stock Code：" +
                              _vm._s(_vm.jsonData.companyCode) +
                              " ｜ Industry： " +
                              _vm._s(_vm.jsonData.xfhyEng)
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
          _c("div", { staticClass: "logo" }, [
            _c("img", { attrs: { src: _vm.logoImg } }),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "line" }, [
      _c("div", { staticClass: "line-bg" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "right" }, [
      _c("img", {
        attrs: { src: require("../assets/image/blue/home_right.png") },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "line" }, [
      _c("div", { staticClass: "line-bg" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }